import * as Sentry from '@sentry/browser';

export const FATAL = 'fatal';
export const ERROR = 'error';
export const WARN = 'warning';
export const INFO = 'info';
export const DEBUG = 'debug';

export const SENTRY_LOG_LEVELS = {
    FATAL,
    ERROR,
    WARN,
    INFO,
    DEBUG
};

export const sentryInit = (dsn, mallCode, orderingToken, level=ERROR) => {
    Sentry.init({dsn});
    Sentry.configureScope((scope) => {
        scope.setLevel(level);
        scope.setTag('mallCode', mallCode);
        scope.setTag('orderingToken', orderingToken);
    });
};

const logMessage = (level, message, tags, extras, fingerprints) => {
    Sentry.withScope((scope) => {
        if (fingerprints !== undefined) {scope.setFingerprint(['{{ default }}', ...fingerprints])}
        if (tags !== undefined) {Object.keys(tags).map( key => scope.setTag(key, tags[key])) }
        if (extras !== undefined) {Object.keys(extras).map( key => scope.setTag(key, extras[key])) }
        Sentry.captureMessage(message, level)
    });
};
export const logWarning = (message, tags, extras, fingerprints) => logMessage(WARN, message, fingerprints, tags, extras);
export const logInfo = (message, tags, extras, fingerprints) => logMessage(INFO, message, fingerprints, tags, extras);
export const logDebug = (message, tags, extras, fingerprints) => logMessage(DEBUG, message, fingerprints, tags, extras);
export const logException = (exception, tags, extras, fingerprints) => {
    Sentry.withScope((scope) => {
        if (fingerprints !== undefined) {scope.setFingerprint(['{{ default }}', ...fingerprints])}
        if (tags !== undefined) {Object.keys(tags).map( key => scope.setTag(key, tags[key])) }
        if (extras !== undefined) {Object.keys(extras).map( key => scope.setTag(key, extras[key])) }
        Sentry.captureException(exception)
    });
};

export const logAxiosError = (error) => {
    const request = error.request || {};
    error.name = 'Axios Request Error';
    logException(error, {status: request.status, responseURL: request.responseURL });
};
